import * as yup from 'yup';

import type { WebhookEventFormatsItem } from 'api';

import { endpointUrlValidation } from './endpointUrl';

export const addWebhookModalSchema = yup
  .object({
    endpointUrl: endpointUrlValidation().required(),
    businessUnitUuid: yup.string().label('Business unit').required(),
    xAuthUuid: yup.string().label('X-Auth-UUID').required(),
    selectedEvents: yup.array().of(yup.string().required()).min(1).required(),
    eventFormats: yup
      .mixed<Record<string, WebhookEventFormatsItem>>()
      .required()
  })
  .required();

export type AddWebhookFormValues = yup.InferType<typeof addWebhookModalSchema>;
